export default "__VITE_ASSET__BGL0W6m8__"